(function () {
  var STORAGE_KEY = 'hb_breadcrumb_ref';
  var page = window.__breadcrumbPage;

  if (!page || !page.type) return;

  function escapeHtml(str) {
    var el = document.createElement('span');
    el.appendChild(document.createTextNode(str));
    return el.innerHTML;
  }

  // On product pages with fallback breadcrumbs: replace middle crumbs with stored referrer
  if (page.type === 'product') {
    var nav = document.querySelector('.breadcrumbs[data-breadcrumb-source="fallback"]');
    if (nav) {
      var stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        try {
          var referrer = JSON.parse(stored);
          if (referrer.url && referrer.url !== '/' && referrer.title) {
            var list = nav.querySelector('.breadcrumbs__list');
            if (list) {
              // Remove any existing middle crumbs (between Home and current)
              var middleItems = list.querySelectorAll(
                '.breadcrumbs__item:not(:first-child):not(.breadcrumbs__item--current)'
              );
              middleItems.forEach(function (item) {
                item.remove();
              });

              // Insert referrer crumb before the current item
              var currentItem = list.querySelector('.breadcrumbs__item--current');
              if (currentItem) {
                var li = document.createElement('li');
                li.className = 'breadcrumbs__item';
                li.innerHTML =
                  '<span class="breadcrumbs__separator" aria-hidden="true">/</span>' +
                  '<a href="' + escapeHtml(referrer.url) + '" class="breadcrumbs__link">' +
                  escapeHtml(referrer.title) + '</a>';
                list.insertBefore(li, currentItem);
              }
            }
          }
        } catch (e) {
          // Ignore malformed data
        }
      }
    }
  }

  // Track clicks on product links — store current page as referrer
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';

    // Only store referrer from non-product, non-homepage pages
    if (href.includes('/products/') && page.type !== 'product' && page.url !== '/') {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ title: page.title, url: page.url })
      );
    }
  });
})();
